// extracted by mini-css-extract-plugin
export default {"container":"all-video-page_container__HbXUa","content":"all-video-page_content__xBfYf"};